var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4C0 5.06087 0.421427 6.07828 1.17157 6.82843C1.92172 7.57857 2.93913 8 4 8C5.06087 8 6.07828 7.57857 6.82843 6.82843C7.57857 6.07828 8 5.06087 8 4C8 2.93913 7.57857 1.92172 6.82843 1.17157C6.07828 0.421427 5.06087 0 4 0ZM4 7.27273C3.57022 7.27273 3.14465 7.18808 2.74758 7.02361C2.35052 6.85914 1.98973 6.61807 1.68583 6.31417C1.38193 6.01027 1.14086 5.64948 0.976394 5.25242C0.811924 4.85535 0.727273 4.42978 0.727273 4C0.727273 3.57022 0.811924 3.14465 0.976394 2.74758C1.14086 2.35052 1.38193 1.98973 1.68583 1.68583C1.98973 1.38193 2.35052 1.14086 2.74758 0.976394C3.14465 0.811924 3.57022 0.727273 4 0.727273C4.86798 0.727273 5.70041 1.07208 6.31417 1.68583C6.92792 2.29959 7.27273 3.13202 7.27273 4C7.27273 4.86798 6.92792 5.70041 6.31417 6.31417C5.70041 6.92792 4.86798 7.27273 4 7.27273Z",
    fill: "url(#paint0_linear_6741_8384)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6741_8384",
    x1: 4,
    y1: 0,
    x2: 4,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.5e9789104af89f51fd60a44ed9514142.svg";
export { ForwardRef as ReactComponent };